import React, { useMemo } from 'react';
import ContainerHeader from '../components/ContainerHeader';
import {
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  Filter,
  GridComponent,
  Group,
} from '@syncfusion/ej2-react-grids';
import { Inject, Page, Sort, Search, Toolbar } from '@syncfusion/ej2-react-grids';
import { Button } from '@material-ui/core';
import usePurchaseRequisitionController from './CustomHooks/usePurchaseReqHook';
import AddPurchaseRequisitionForm from './components/PurchaseRequisitionForm';
import { Box, Tab, Tabs } from '@mui/material';
import ConfirmationDialog from '../components/ConfirmDialogs/ConfirmationDialog';
import { dateTemplate } from '../GenTask/components/SharedFormFields';
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
class DebugBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught error:', error, info);
  }
  render() {
    if (this.state.hasError) return <div>Error in grid rendering</div>;
    return this.props.children;
  }
}

const PurchaseRequisitionPage = props => {
  const pageSettings = useMemo(
    () => ({
      pageSize: 30,
      pageSizes: [5, 10, 20, 30, 40],
    }),
    [],
  );
  const filterSettings = {
    type: 'Excel',
  };

  const {
    handleAddNewPurchaseReqButtonClick,
    openPurchaseReqAddModal,
    currentTabPurchaseReqData,
    setOpenPurchaseReqAddModal,
    handlePurchseReqFormSubmit,
    handleTabChange,
    currentTab,
    purchaseReqData,
    openEditPurchaseReqForm,
    selectedPurchaseReqData,
    isPurchaseReqEdit,
    handleRfqEdit,
    openConfirmationDialog,
    setOpenConfirmationDialog,
    handleOpenConfirmationDialog,
    confirmationDialogProps,
    closeConfirmationDialog,
  } = usePurchaseRequisitionController();
  const contextMenuClick = args => {};
  const toolbarOptions = [
    { text: 'Search', tooltipText: 'Search', prefixIcon: 'e-search', id: 'search' },
    // { text: 'Add Woodchip Sample', id: 'addNewWoodChipSample', tooltipText: 'Add a new Woodchip Sample' },
    {
      template: () => (
        <div style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
          <Button
            size="small"
            variant="contained"
            color="primary"
            style={{ marginLeft: '10px' }}
            onClick={() => handleAddNewPurchaseReqButtonClick(null)}>
            + Add Purchase Requisition
          </Button>
        </div>
      ),
      id: 'addNewWoodChipSample',
      align: 'Left',
    },
  ];

  const editOptions = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Dialog' };
  const handleActionBegin = args => {
    if (args.requestType === 'beginEdit' || args.requestType === 'save') {
    }
  };

  function editLinkTemplate(props) {
    return (
      <Button
        key={`${props.id}_site`}
        style={{ color: 'blue', fontWeight: 'bold', width: '100%' }}
        onClick={() => openEditPurchaseReqForm(props)}>
        {props.id}
      </Button>
    );
  }

  const rowDataBound = args => {
    const isDieselPurchase = args.data['purchaseOrReturn'] === 'Diesel Purchase';
    const status = args.data['requisitionStatus']; // Assuming the field is 'status'
    console.log('Row Data Bound - Status:', status, args.data);
    if (isDieselPurchase && status === 'Requested') {
      args.row.style.backgroundColor = '#ffebee'; // Light Red
    } else if (status === 'Ordered') {
      args.row.style.backgroundColor = '#f5f5f5'; // Grey
    } else if (status === 'Approved') {
      args.row.style.backgroundColor = '#e8f5e9'; // Light Green
    } else {
      args.row.style.backgroundColor = '#ffffff'; // Default
    }
  };

  return (
    // <PageContainer heading={<IntlMessages id="pages.dashboard" />} breadcrumbs={breadcrumbs}>
    <div className="app-wrapper siteWrapper">
      <ContainerHeader match={props.match} title={'Purchase Requisition Form'} />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={currentTab} onChange={handleTabChange} aria-label="basic tabs example">
          <Tab color="primary" label="All" {...a11yProps(0)} />
          <Tab color="primary" label="Diesel Purchase" {...a11yProps(1)} />
          <Tab color="primary" label="Recharge" {...a11yProps(2)} />
          <Tab color="primary" label="BR Reports" {...a11yProps(3)} />
          <Tab color="primary" label="Req" {...a11yProps(4)} />
        </Tabs>
      </Box>
      <div style={{ height: 'calc(100vh - 195px)', width: '100%', paddingTop: '0.5rem' }}>
        <DebugBoundary>
          <GridComponent
            rowDataBound={rowDataBound}
            dataSource={currentTabPurchaseReqData}
            filterSettings={filterSettings}
            allowPaging={true}
            pageSettings={pageSettings}
            allowSorting={true}
            allowTextWrap={true}
            allowResizing={true}
            allowMultiSorting={true}
            allowReordering={true}
            allowFiltering={true}
            style={{
              minHeight: 'auto !important',
            }}
            actionBegin={handleActionBegin}
            height="100%"
            toolbar={toolbarOptions}>
            <ColumnsDirective>
              <ColumnDirective
                field="id"
                headerText="Edit Link"
                width="80"
                textAlign="Left"
                isPrimaryKey={true}
                template={editLinkTemplate}
              />
              <ColumnDirective field="purchaseOrReturn" headerText="Purchase Or Return" width="100" />
              <ColumnDirective field="requisitionStatus" headerText="Status" width="100" />
              <ColumnDirective field="submissionDate" headerText="Date" width="100" formatter={dateTemplate} />
              <ColumnDirective field="pO_ReqNumber" headerText="PO Req Number" width="100" />
              <ColumnDirective field="originatedBy" headerText="Originated By" width="100" />

              <ColumnDirective field="totalNetValue" headerText="Total Net Value" width="80" textAlign="Right" />
              <ColumnDirective field="fileUploaded" headerText="Files Uploaded" width="80" />
              <ColumnDirective field="emailToSupplier" headerText="Email To Supplier" width="120" />
              <ColumnDirective field="departmentMachine" headerText="Department Machine" width="100" />
              <ColumnDirective field="department2Machine2" headerText="Department2 Machine2" width="100" />
              <ColumnDirective field="supplierName" headerText="Supplier Name" width="100" />
              <ColumnDirective field="description" headerText="Description" width="100" />
            </ColumnsDirective>
            <Inject services={[Page, Sort, Filter, Group, Search, Toolbar]} />
          </GridComponent>
        </DebugBoundary>
      </div>
      <AddPurchaseRequisitionForm
        handlePurchseReqSubmit={handlePurchseReqFormSubmit}
        open={openPurchaseReqAddModal}
        setOpen={setOpenPurchaseReqAddModal}
        isEdit={isPurchaseReqEdit}
        selectedPurchaseReq={selectedPurchaseReqData}
        handleRfqEdit={handleRfqEdit}
        handleOpenConfirmationDialog={handleOpenConfirmationDialog}
      />
      <ConfirmationDialog
        open={openConfirmationDialog}
        setOpen={setOpenConfirmationDialog}
        confirmationFun={confirmationDialogProps.confirmFnc}
        declineFunction={confirmationDialogProps.cancleFnc}
        confirmationText={confirmationDialogProps.confirmText}
      />
    </div>
  );
};

export default PurchaseRequisitionPage;
